<template> 
    <div class="product-details-container"> 
        <Summary :product='product'/>
        <!-- <ProductButtons  v-if='in_stock' :product='product' :variant_code='variant_code' :in_stock='in_stock' @updatedCartListener='updatedCartListener'/> -->
        <LockItInProductButtons  v-if='in_stock && !hide_add_to_cart' :product='product' :variant_code='variant_code' :in_stock='in_stock' @updatedCartListener='updatedCartListener' @addToCartListener="addedToCart" @removedFromCartListener="removedFromCart"/>
    </div>
</template>
<script>
import Summary from '@/ecom/components/products/single_product/details/Summary.vue';
import ProductButtons from '@/ecom/components/products/single_product/details/ProductButtons.vue';
import LockItInProductButtons from '@/ecom/components/products/single_product/details/LockItInProductButtons.vue';

export default {
    components: {Summary, ProductButtons, LockItInProductButtons},
    emits: ['updatedCartListener', 'addToCartListener', 'removedFromCartListener'],
    props: ['product', 'variant_code', 'in_stock', 'hide_add_to_cart'],
    methods:{
        updatedCartListener(){
            this.$emit('updatedCartListener');
        },
        addedToCart(product, quantity){
           this.$emit('addToCartListener', product, quantity);
        },
        removedFromCart(product, quantity){
           this.$emit('removedFromCartListener', product, quantity);
        }
    }
}
</script>
<style lang="scss" scoped>
.product-details-container{
    display: flex;
    gap: 70px;
    flex-wrap: wrap;
    @media(max-width:1292px) {
        gap:30px;
        justify-content: center;
    } 
}
</style>